import {
  useCurrentBlockIndex,
  useCurrentPage,
  useDocumentActions,
  useScrollBlockIntoView,
} from '@/modules/documents'
import { cn } from '@/utils'

function resolveImages(html: string, images: Record<string, string>): string {
  return Object.entries(images).reduce((result, [filename, url]) => {
    const imageRegex = new RegExp(`src="${filename}"`, 'g')
    const newSrc = `src="${url}"`
    return result.replace(imageRegex, newSrc)
  }, html)
}

export const DocumentBlocks = () => {
  const page = useCurrentPage()
  const currentBlockIndex = useCurrentBlockIndex()
  const { setCurrentBlock } = useDocumentActions()
  const { blockRefs } = useScrollBlockIntoView()

  if (!page) return null

  return (
    <div className="flex flex-col gap-4 overflow-y-auto rounded-lg border bg-white p-4 flex-1 min-h-0">
      {page.blocks.map((block, i) => (
        <div
          key={block.bbox.join(',')}
          ref={(el) => {
            blockRefs.current[i] = el
          }}
          className={cn(
            'prose prose-sm max-w-none transition-colors outline outline-transparent',
            currentBlockIndex === i && 'outline-brand/70 bg-brand/10',
            block.type === 'Picture' &&
              '[&_img]:mx-auto border border-muted text-center text-muted-foreground',
          )}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: block from lukita
          dangerouslySetInnerHTML={{
            __html: resolveImages(
              block.html.replace(/\sstyle="[^"]*"/g, ''),
              block.images,
            ),
          }}
          onMouseEnter={() => setCurrentBlock(i)}
          onMouseLeave={() => setCurrentBlock(null)}
        />
      ))}
    </div>
  )
}
